import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, throwError, timer } from 'rxjs';

import { isSilentAuthStateMismatch, silentAuthRetryDelay } from '../auth/silent-auth';

const MAX_RETRIES = 2;

/**
 * Recovers from `state_mismatch` errors raised by `AuthHttpInterceptor` when a sibling
 * micro-frontend's Auth0 iframe response is delivered to this app's listener.
 *
 * Must be registered before `AuthHttpInterceptor` so that it wraps the token acquisition.
 */
@Injectable()
export class SilentAuthRetryInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: MAX_RETRIES,
        delay: (error: unknown, retryCount: number) =>
          isSilentAuthStateMismatch(error) ? timer(silentAuthRetryDelay(retryCount)) : throwError(() => error),
      })
    );
  }
}
